import { Component, Input } from '@angular/core';
import { ModalsComponent } from '../modals.component';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-nice-legal-text',
  templateUrl: './nice-legal-text.component.html',
  styleUrls: ['./nice-legal-text.component.css']
})
export class NiceLegalTextComponent extends ModalsComponent {
  @Input() type:'personal-info'|'third-party-info'|'social-security-info'
  constructor(
    modalRef:BsModalRef,
  ) { 
    super(modalRef);
  }

}
